/**
 * The one sentence under the word "Shop".
 *
 * It lives here rather than inline in the page because it has three cases and
 * only two of them were written. R-140 replaced a hardcoded "Three labels" with
 * `brands.length`, which fixed the count and left the sentence:
 *
 *     0 labels, one checkout. Every price includes GST.
 *
 * Zero is not a hypothetical. The brand list comes from what is published, and
 * an empty published catalogue is the state this client's database was in when
 * the home page rendered a blank section during their show (R-352). The page
 * already has an empty state for the grid below. The line above it still
 * announced a shop with no labels in it. R-382.
 */
export function shopSubtitle(brands: { name: string }[]): string {
  if (brands.length === 0) return 'The store is being set up. Every price includes GST.';
  if (brands.length === 1) return `Everything from ${brands[0]!.name}. Every price includes GST.`;
  return `${brands.length} labels, one checkout. Every price includes GST.`;
}
